import React from 'react';

import { useScriptTagLink } from 'hooks/useScriptTag.hook';
import logger from 'utils/logger.util';

// eslint-disable-next-line import/extensions
import SCRIPT_BOOKING_FINISH from './booking-finish.js.script';

const L = logger('BookingFinish'); // eslint-disable-line no-unused-vars

const BookingFinish = () => {
  useScriptTagLink(SCRIPT_BOOKING_FINISH);

  return (
    <article data-bem="BookingFinish">
      <h2>Finish</h2>

      <label>
        Received:
        <textarea name="note" readOnly disabled />
      </label>
    </article>
  );
};

export default BookingFinish;
